module.exports = "/images/veil-13.jpg";